
import {createContext, useState} from 'react'

const Context = createContext()

export const ProyectoContextProvider = ({children}) => {
 const [allProyectos, setAllProyectos] = useState([])
 const [proyectos, setProyectos] = useState([]);
 const [proyecto, setProyecto] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allProyectos, setAllProyectos, proyectos, setProyectos, proyecto, setProyecto, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context